export default __webpack_public_path__ + "static/media/image12.64a9d839.png";